import { NominationRole } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getCountryAwardNominationRole: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  nominationId: number,
  accessToken?: string,
) => Promise<NominationRole> = (fetchContext, programId, countryId, nominationId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/nominations/${nominationId}/role`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<NominationRole>(fetchContext.errorStore, response, 'get country award nomination role'));
